import * as React from 'react';
import {
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  Tooltip,
} from 'recharts';
import { IProfileResult } from '../../../../data/providers/reports/profileReportProvider';
import { colors } from '../../colors';
import { Tooltip as CustomTooltip } from './Tooltip';

interface IProps {
  data: IProfileResult[];
  scaled: boolean;
  isPdf: boolean;
  height: number;
  width: number;
}

const getLabel = (
  isPdf: boolean,
  metricCount: number
): (() => React.ReactElement) => {
  return CustomLabel.bind(null, isPdf, metricCount);
};

export const ProfileRadar = (props: IProps): React.ReactElement => {
  if (props.data.length < 3) return null;

  console.log(props.data);

  return (
    <React.Fragment>
      <RadarChart
        cx='50%'
        cy='50%'
        data={props.data}
        height={props.height}
        width={props.width}
      >
        <PolarAngleAxis
          tick={getLabel(props.isPdf, props.data.length)}
          tickLine={false}
          dataKey='label'
          axisLine={{
            strokeOpacity: 0.5,
          }}
        />

        <PolarGrid stroke='var(--color-text)' strokeOpacity={0.5} />

        <Radar
          name={''}
          dataKey='zscore'
          stroke={colors[0]}
          fillOpacity={0.5}
          fill={colors[0]}
          dot
          strokeWidth={2}
          isAnimationActive={false}
        />

        <Radar
          name={''}
          dataKey='populationScore'
          fillOpacity={0.5}
          fill={colors[1]}
          strokeWidth={2}
          activeDot={false}
          isAnimationActive={false}
        />
        <PolarRadiusAxis
          angle={90}
          domain={props.scaled ? [0, 100] : [-4, 4]}
          stroke='var(--color-text)'
          strokeOpacity={0.5}
          dx={5}
        />
        <Tooltip content={CustomTooltip} />
      </RadarChart>
    </React.Fragment>
  );
};

// tslint:disable-next-line:no-any
const CustomLabel = (
  isPdf: boolean,
  _: number,
  opts: any
): React.ReactElement => {
  if (typeof opts?.payload?.value === 'string') {
    const parts: string[] = opts.payload.value?.split(':');
    const { coordinate } = opts.payload;
    let testTypeOffset: number;
    let metricOffset: number;

    switch (Math.round(coordinate)) {
      case 90:
        testTypeOffset = opts.y - 22;
        metricOffset = opts.y - 10;
        break;
      case -90:
        testTypeOffset = opts.y + 10;
        metricOffset = opts.y + 22;
        break;
      default:
        testTypeOffset = opts.y;
        metricOffset = opts.y + 12;
        break;
    }
    return (
      <React.Fragment>
        <g>
          <text
            x={opts.x}
            y={testTypeOffset}
            textAnchor={opts.textAnchor}
            dominantBaseline='central'
            fontSize={isPdf ? '3mm' : '12px'}
            fill='var(--color-text)'
          >
            {parts?.[1]}
          </text>
          <text
            x={opts.x}
            y={metricOffset}
            textAnchor={opts.textAnchor}
            dominantBaseline='central'
            fontSize={isPdf ? '3mm' : '12px'}
            fill='var(--color-text)'
          >
            {parts?.[0]}
          </text>
        </g>
      </React.Fragment>
    );
  } else {
    return null;
  }
};
